import { ImageViewModel } from '@/src/shared/presentation/view-models/image.viewModel';

import { TextFieldViewModel } from '../text-field.viewModel';

import type { ICMSBlockViewModel } from '../../types/cms-block.viewModel';
import type { TwoColumnsBlock } from '@/src/cms/domain/models/blocks/two-columns-block';

export class TwoColumnsBlockViewModel implements ICMSBlockViewModel {
  readonly $type = 'two-columns-block' as const;

  hide: boolean;
  leftTitle: string;
  leftBody: TextFieldViewModel;
  leftBackgroundImage: ImageViewModel;
  leftLogo: ImageViewModel | null;
  rightTitle: string;
  rightBody: TextFieldViewModel;
  rightBackgroundImage: ImageViewModel;
  rightLogo: ImageViewModel | null;

  constructor(data: {
    hide: boolean;
    leftTitle: string;
    leftBody: TextFieldViewModel;
    leftBackgroundImage: ImageViewModel;
    leftLogo: ImageViewModel | null;
    rightTitle: string;
    rightBody: TextFieldViewModel;
    rightBackgroundImage: ImageViewModel;
    rightLogo: ImageViewModel | null;
  }) {
    this.hide = data.hide;
    this.leftTitle = data.leftTitle;
    this.leftBody = new TextFieldViewModel(data.leftBody);
    this.leftBackgroundImage = new ImageViewModel(data.leftBackgroundImage);
    this.leftLogo = data.leftLogo ? new ImageViewModel(data.leftLogo) : null;
    this.rightTitle = data.rightTitle;
    this.rightBody = new TextFieldViewModel(data.rightBody);
    this.rightBackgroundImage = new ImageViewModel(data.rightBackgroundImage);
    this.rightLogo = data.rightLogo ? new ImageViewModel(data.rightLogo) : null;
  }

  static presenter(block: TwoColumnsBlock): TwoColumnsBlockViewModel {
    return new TwoColumnsBlockViewModel({
      hide: block.hide,
      leftTitle: block.leftTitle,
      leftBody: TextFieldViewModel.presenter(block.leftBody),
      leftBackgroundImage: ImageViewModel.presenter(block.leftBackgroundImage),
      leftLogo: block.leftLogo && ImageViewModel.presenter(block.leftLogo),
      rightTitle: block.rightTitle,
      rightBody: TextFieldViewModel.presenter(block.rightBody),
      rightBackgroundImage: ImageViewModel.presenter(block.rightBackgroundImage),
      rightLogo: block.rightLogo && ImageViewModel.presenter(block.rightLogo)
    });
  }
}
